import React from 'react';

function StarRating({ rating }) {
  const fullStars = Math.floor(rating);
  const halfStar = rating - fullStars >= 0.5;
  const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {[...Array(fullStars)].map((_, index) => (
        <span key={index} style={{ color: 'gold' }}>
          ★
        </span>
      ))}
      {halfStar && <span style={{ color: 'gold' }}>☆</span>}
      {[...Array(emptyStars)].map((_, index) => (
        <span key={index} style={{ color: 'lightgray' }}>
          ★
        </span>
      ))}
    </div>
  );
}

export default StarRating;
